import { studentMessagesEN } from './lib/intl/en-US';

export const programId = '5e9a094ab38be21acb02a1f9';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },

    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': studentMessagesEN,
    },
};
